module.exports = __webpack_public_path__ + "img/logo-white.f529dc4f.png";